import { useRef } from 'react';

import { useLazyQuery } from '@apollo/client';
import { t } from 'i18next';

import { ConfirmAction } from '../Modal/ConfirmAction';
import { useStrategiesContext } from './StrategiesContext';

import { GET_STRATEGY_DATA } from '../../http/apollo-queries';

export const GetStrategyData = ({
  strategyId,
  close,
}: {
  strategyId?: string;
  close?(): void;
}) => {
  const { strategy, closeModal } = useStrategiesContext();
  !strategyId && (strategyId = strategy?.id);
  !close && (close = closeModal);

  const a = useRef(window.document.createElement('a'));

  const [getStrategyData] = useLazyQuery(GET_STRATEGY_DATA, {
    variables: { strategyId },

    onCompleted: (data) => {
      if (
        data.getStrategyData.status === 'SUCCESS' &&
        data.getStrategyData.url
      ) {
        a.current.href = data.getStrategyData.url;
        a.current.click();
        a.current.remove();
      }
      close?.();
    },
  });

  return (
    <ConfirmAction
      onlyFirstStep
      saveButtonName="DOWNLOAD"
      title={t('modals.getStrategyData.title')}
      finish={close}
      cancel={close}
      save={getStrategyData}
    />
  );
};
